import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleProp, TextStyle } from 'react-native'

interface NameProps {
    children: string
    numberOfLines: number
    style?: StyleProp<TextStyle>
}

const Name: FC<NameProps> = ({ children, numberOfLines, style }) => {
    return (
        <Typography.Heading variant="h4" numberOfLines={numberOfLines} style={style}>
            {children}
        </Typography.Heading>
    )
}

export default Name
